import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  FormGroup,
  FormLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Card,
  CardContent,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  APP_STATE_ACTION_TYPE_USER_THEME, APP_STATE_ACTION_TYPE_USE_SYS_THEME,
} from '../../state/seed-states';
import { settingsSettingablesPropTypes, defaultSettingsSettingablesPropTypes } from './settings-page-prop-types';

const SeedThemeSettings = ({
  sysTheme,
  useSysTheme,
  theme,
  supportedThemes,
  onChangeSettings,
  settingables,
}) => {
  const intl = useIntl();

  return (
    <Card>
      <CardContent>
        <Box p={1}>
          <Typography variant="h5">
            <FormattedMessage
              id="seed.settings.heading.theme"
            />
          </Typography>
          <Box p={1}>
            <FormGroup>
              {
              settingables[APP_STATE_ACTION_TYPE_USE_SYS_THEME]
                ? (
                  <>
                    <FormControlLabel
                      control={(
                        <Switch
                          size="small"
                          checked={useSysTheme}
                          onChange={(e) => onChangeSettings(APP_STATE_ACTION_TYPE_USE_SYS_THEME, e.target.checked, 'boolean')}
                          name="useSysTheme"
                        />
                      )}
                      label={(
                        <FormattedMessage
                          id="seed.settings.label.useSysTheme"
                          values={{
                            theme: intl.formatMessage({ id: sysTheme }),
                          }}
                        />
                    )}
                    />
                    <Box mt={1} />
                  </>
                ) : ''
              }
              {
              settingables[APP_STATE_ACTION_TYPE_USER_THEME]
                ? (
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <FormattedMessage
                        id="seed.settings.label.theme"
                      />
                    </FormLabel>
                    <RadioGroup
                      aria-label="theme"
                      name="theme"
                      value={theme}
                      onChange={(event) => onChangeSettings(APP_STATE_ACTION_TYPE_USER_THEME, event.target.value, 'string')}
                    >
                      {
                      supportedThemes.map((th) => (
                        <FormControlLabel
                          key={`settings-theme-${th}`}
                          value={th}
                          control={<Radio size="small" disabled={useSysTheme} color="primary" />}
                          label={<FormattedMessage id={th} />}
                        />
                      ))
                    }
                    </RadioGroup>
                  </FormControl>
                ) : ''
              }
            </FormGroup>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

SeedThemeSettings.propTypes = {
  sysTheme: PropTypes.string.isRequired,
  useSysTheme: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  supportedThemes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeSettings: PropTypes.func.isRequired,
  settingables: settingsSettingablesPropTypes,
};

SeedThemeSettings.defaultProps = {
  settingables: defaultSettingsSettingablesPropTypes,
};

export default SeedThemeSettings;
